/* Produktkatalog, Regeln und Begruendungstexte fuer den Rasenrechner V2.
   Aenderungen bitte NUR hier. Layout liegt in rasenrechner.liquid, Logik in rasenrechner.js
   ---------------------------------------------------------------
   NEU in V2: zwei Saisons. saisonProdukte.sommer und saisonProdukte.herbst enthalten
   je fluessig, kristall und duo. Welche Saison gilt, entscheidet der URL-Parameter
   ?saison=sommer oder ?saison=herbst. Ohne Parameter gilt HERBST.
   nachsaat, erde und handstreuer sind saisonunabhaengig und stehen in produkte.

   zustaende[i]: anteil = geschaetzter Anteil kahler Flaeche, boost = mehr Duenger einplanen
   boostFaktor:  womit der Duengerbedarf bei boost multipliziert wird. Von Bernhard
                 noch zu bestaetigen, siehe Mengenlogik-PDF vom 21.08.2026.
   sizes[]:      deckung = wie viele m2 das Gebinde abdeckt, obere Grenze des Etiketts
                 menge   = Zahlenwert in der Produkteinheit, fuer die Bedarfszeile
   rate:         Produkteinheit je m2. Nur setzen, wenn sie ueber alle Gebinde gleich ist.
   ACHTUNG Kristall Herbst: die Reichweiten kommen von den Variantentiteln im Shop
   (2,5 kg fuer 25-50 m2) und sind VIEL kleiner als beim Sommer-Kristall
   (2,5 kg fuer 100-200 m2). Das ist Stand der Etiketten, nicht unsere Entscheidung.
*/
window.BLRR_KATALOG = {
  boostFaktor: 2,

  zustaende: [
    { kurz: 'dicht und grün',          anteil: 0.00, boost: 0 },
    { kurz: 'etwas dünn',              anteil: 0.05, boost: 0 },
    { kurz: 'einzelne kahle Stellen',  anteil: 0.15, boost: 0 },
    { kurz: 'größtenteils kahl',        anteil: 0.35, boost: 1 }
  ],

  saetze: {
    menge_basis:      'Du hast <strong>{qm} m²</strong> angegeben. Das ist die Menge für eine volle Anwendung.',
    menge_boost:      'Weil dein Rasen <strong>{zustand}</strong> ist, haben wir mehr eingeplant. Eine ausgezehrte Fläche zieht deutlich mehr Nährstoffe als eine gepflegte.',

    fluessig_basis:   'Flüssig heißt: Die Nährstoffe sind sofort da, weil sie sich nicht erst im Boden lösen müssen. Flasche an den Gartenschlauch, einmal über die Fläche, fertig. Erste Ergebnisse nach etwa 7 Tagen.',
    fluessig_schnell: 'Du wolltest <strong>schnelle Wirkung</strong>. Genau dafür ist flüssig gemacht: Die Nährstoffe hängen im Wasser und sind sofort an der Wurzel, statt sich erst auflösen zu müssen. Nach rund 7 Tagen siehst du den Unterschied.',
    kristall_langzeit:'Du wolltest <strong>Langzeitwirkung</strong>. Die Kristalle lösen sich nach und nach auf, statt alles auf einmal abzugeben. Der Rasen bekommt über Wochen gleichmäßig Nachschub, statt einmal viel und danach nichts mehr.',
    duo_beides:       'Schnelle Wirkung und Langzeitwirkung waren dir <strong>beide</strong> wichtig. Mit einem einzelnen Dünger heißt das: einmal jetzt, und in ein paar Wochen nochmal raus.',
    duo_ablauf:       'Das Duo macht beides in einem Durchgang. An <strong>Tag 1</strong> kommt der Kristalldünger in den Boden, an <strong>Tag 3</strong> der flüssige obendrauf. Ab Tag 7 siehst du die ersten Ergebnisse, und der Kristallteil versorgt weiter, wenn der schnelle Effekt längst durch ist.',
    einfach_fluessig: 'Du wolltest es <strong>einfach</strong>. Kein Streuwagen, kein Abmessen, kein Ausrechnen: Flasche an den Schlauch, aufdrehen, einmal über die Fläche laufen.',
    einfach_kristall: 'Du wolltest es <strong>einfach</strong>. Die Kristalle lassen sich von Hand streuen, ein Streuwagen ist nicht nötig. Wer einen hat, kann ihn nehmen, muss aber nicht.',
    duenger_wasser:   'Wichtig danach: gründlich wässern, <strong>15 bis 20 Liter je m²</strong>. Der häufigste Grund für ausbleibende Ergebnisse ist nicht der Dünger, sondern zu wenig Wasser.',

    herbst_warum:     'Im Herbst geht es nicht mehr ums Wachsen, sondern ums Überstehen. Der Herbstdünger hat im Vergleich zum Sommerdünger deutlich weniger Stickstoff und doppelt so viel Kalium. Kalium macht keine Farbe, Kalium macht Frostfestigkeit.',

    handstreuer_warum:  'Kristalle müssen gleichmäßig auf die Fläche. Von Hand geht das, aber ungleichmäßig gestreut wird der Rasen streifig: zu viel brennt, zu wenig bringt nichts.',
    handstreuer_hinweis:'Mit dem Streuer schaffst du <strong>{qm} m²</strong> in einem gleichmäßigen Durchgang. Wenn du schon einen hast, brauchst du ihn natürlich nicht.',

    nachsaat_flaeche: 'Bei <strong>{qm} m²</strong> und <strong>{zustand}</strong> rechnen wir mit rund <strong>{luecken} m²</strong> kahler Fläche.',
    nachsaat_warum:   'Dünger kräftigt nur, was schon da ist. Wo gar nichts mehr wächst, hilft ausschließlich neue Saat.',
    nachsaat_wasser:  'Bis die Saat keimt, darf sie nicht austrocknen. Lieber öfter kurz wässern als einmal viel, und die ersten zwei bis drei Wochen nicht mähen.',

    erde_menge:       'Die Erde kommt dünn über die Saat, wir rechnen mit rund <strong>1 Liter je m²</strong>.',
    erde_warum:       'Die Saat keimt nur mit Bodenkontakt. Ohne Abdeckung trocknet sie aus oder wird von Vögeln geholt.'
  },

  saisonProdukte: {
    sommer: {
      fluessig: {
        name: 'RASENBLITZ™ Sommerdünger',
        handle: 'rasenblitz-sommerdunger',
        einheit: 'Liter',
        rate: 0.01,
        img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/Produktbild_BodenLiebe_Rasenblitz_Sommerduenger_1l_Stoerer_300x.jpg',
        sizes: [
          { deckung: 100,  menge: 1,  id: 50924231950683, price: 34.85, label: '1 Liter · für 50-100 m²' },
          { deckung: 200,  menge: 2,  id: 50924231983451, price: 44.95, label: '2 Liter · für 100-200 m²' },
          { deckung: 500,  menge: 5,  id: 50924232016219, price: 64.95, label: '5 Liter · für 250-500 m², inkl. Sprühflasche' },
          { deckung: 1000, menge: 10, id: 50924232048987, price: 94.95, label: '10 Liter · für 500-1000 m², inkl. Sprühflasche und 500 g Nachsaat' }
        ]
      },
      kristall: {
        name: 'RASENBLITZ Kristalldünger Sommer',
        handle: 'rasenblitz-kristalldunger-sommer',
        einheit: 'kg',
        img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/Produktbild_BodenLiebe_Rasenblitz_Kristallduenger_Sommerduenger_5kg_Stoerer_05c70ebe-7b2b-4448-99be-61d5f57501d2_300x.jpg',
        sizes: [
          { deckung: 200,  menge: 2.5, id: 52851977912667, price: 24.99, label: '2,5 kg · für 100-200 m²' },
          { deckung: 400,  menge: 5,   id: 52851977945435, price: 39.99, label: '5 kg · für 200-400 m²' },
          { deckung: 600,  menge: 10,  id: 52851977978203, price: 59.99, label: '10 kg · für 400-600 m²' },
          { deckung: 1200, menge: 20,  id: 52851978010971, price: 79.99, label: '20 kg · für 600-1200 m²' }
        ]
      },
      duo: {
        name: 'RASENBLITZ™ Traumrasen Sommer Duo',
        handle: 'rasenblitz-traumrasen-duo',
        einheit: 'Set',
        img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/1_300x.jpg',
        sizes: [
          { deckung: 100,  menge: 1, id: 53398547399003, price: 49.95,  label: '5 kg + 2 Liter · für 100 m²' },
          { deckung: 200,  menge: 1, id: 53398562242907, price: 69.95,  label: '10 kg + 5 Liter · für 200 m²' },
          { deckung: 300,  menge: 1, id: 53398566601051, price: 99.95,  label: '20 kg + 5 Liter · für 300 m²' },
          { deckung: 400,  menge: 1, id: 53398569910619, price: 139.95, label: '25 kg + 10 Liter · für 400 m²' },
          { deckung: 500,  menge: 1, id: 53398570074459, price: 159.95, label: '30 kg + 10 Liter · für 500 m²' },
          { deckung: 600,  menge: 1, id: 53398570533211, price: 179.95, label: '35 kg + 10 Liter · für 600 m²' },
          { deckung: 700,  menge: 1, id: 53398570991963, price: 229.95, label: '45 kg + 15 Liter · für 700 m²' },
          { deckung: 800,  menge: 1, id: 53398571614555, price: 249.99, label: '50 kg + 15 Liter · für 800 m²' },
          { deckung: 900,  menge: 1, id: 53398572794203, price: 279.95, label: '55 kg + 20 Liter · für 900 m²' },
          { deckung: 1000, menge: 1, id: 53398574629211, price: 289.95, label: '60 kg + 20 Liter · für 1.000 m²' }
        ]
      }
    },
    herbst: {
      fluessig: {
        name: 'RASENBLITZ™ Herbstdünger',
        handle: 'rasenblitz-herbstduenger',
        einheit: 'Liter',
        rate: 0.01,
        img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/Produktbild_BodenLiebe_Rasenblitz_Herbstduenger_1l.jpg?v=1787117345',
        sizes: [
          { deckung: 100,  menge: 1,  id: 51237803950427, price: 34.85, label: '1 Liter · für 50-100 m²' },
          { deckung: 200,  menge: 2,  id: 51237803983195, price: 44.95, label: '2 Liter · für 100-200 m²' },
          { deckung: 500,  menge: 5,  id: 51237804015963, price: 64.95, label: '5 Liter · für 250-500 m², inkl. Sprühflasche' },
          { deckung: 1000, menge: 10, id: 51237804048731, price: 94.95, label: '10 Liter · für 500-1000 m², inkl. Sprühflasche und 500 g Nachsaat' }
        ]
      },
      kristall: {
        name: 'RASENBLITZ Kristalldünger Herbst',
        handle: 'rasenblitz-kristalldunger-herbstdunger',
        einheit: 'kg',
        img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/Produktbild_BodenLiebe_Rasenblitz_Kristallduenger_Herbstduenger_5kg.jpg?v=1787035415',
        sizes: [
          { deckung: 50,  menge: 2.5, id: 51436429181275, price: 24.99, label: '2,5 kg · für 25-50 m²' },
          { deckung: 100, menge: 5,   id: 51436429214043, price: 39.99, label: '5 kg · für 50-100 m²' },
          { deckung: 250, menge: 10,  id: 51436429246811, price: 59.99, label: '10 kg · für 100-250 m²' },
          { deckung: 400, menge: 20,  id: 51436429279579, price: 79.99, label: '20 kg · für 200-400 m²' }
        ]
      },
      duo: {
        name: 'RASENBLITZ™ Traumrasen Herbst Duo',
        handle: 'rasenblitz™-traumrasen-herbst-duo',
        einheit: 'Set',
        img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/OTM_Herbst-Duo.png?v=1787230614',
        sizes: [
          { deckung: 100,  menge: 1, id: 53842917556571, price: 49.95,  label: '5 kg + 2 Liter · für 100 m²' },
          { deckung: 200,  menge: 1, id: 53842917589339, price: 69.95,  label: '10 kg + 5 Liter · für 200 m²' },
          { deckung: 300,  menge: 1, id: 53842917622107, price: 99.95,  label: '20 kg + 5 Liter · für 300 m²' },
          { deckung: 400,  menge: 1, id: 53842917654875, price: 139.95, label: '25 kg + 10 Liter · für 400 m²' },
          { deckung: 500,  menge: 1, id: 53842917687643, price: 159.95, label: '30 kg + 10 Liter · für 500 m²' },
          { deckung: 600,  menge: 1, id: 53842917720411, price: 179.95, label: '35 kg + 10 Liter · für 600 m²' },
          { deckung: 700,  menge: 1, id: 53842917753179, price: 229.95, label: '45 kg + 15 Liter · für 700 m²' },
          { deckung: 800,  menge: 1, id: 53842917785947, price: 249.99, label: '50 kg + 15 Liter · für 800 m²' },
          { deckung: 900,  menge: 1, id: 53842917818715, price: 279.95, label: '55 kg + 20 Liter · für 900 m²' },
          { deckung: 1000, menge: 1, id: 53842917851483, price: 289.95, label: '60 kg + 20 Liter · für 1.000 m²' }
        ]
      }
    }
  },

  produkte: {
    handstreuer: {
      name: 'BODENLIEBE™ Handstreuer',
      handle: 'bodenliebe™-handstreuer',
      einheit: 'Stück',
      img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/Produktbild_BodenLiebe_Handstreuer_300x.jpg',
      sizes: [
        { deckung: 99999, menge: 1, id: 51402224501083, price: 32.99, label: 'Handstreuer · für gleichmäßiges Ausbringen' }
      ]
    },
    nachsaat: {
      name: 'RASENBLITZ™ Nachsaat',
      handle: 'premium-nachsaat',
      einheit: 'kg',
      rate: 0.02,
      img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/ProduktBilder_3_300x.png',
      sizes: [
        { deckung: 25,  menge: 0.5, id: 49884771320155, price: 12.99, label: '500 g · für ca. 25 m²' },
        { deckung: 50,  menge: 1,   id: 49884771352923, price: 19.98, label: '1 kg · für ca. 50 m²' },
        { deckung: 100, menge: 2,   id: 49884771385691, price: 27.94, label: '2 kg · für ca. 100 m²' }
      ]
    },
    erde: {
      name: 'RASENBLITZ™ Rasenerde',
      handle: 'naturtalent™-rasenerde',
      einheit: 'Liter',
      rate: 1,
      img: 'https://cdn.shopify.com/s/files/1/0878/2967/6379/files/Produktbild_BodenLiebe_Rasenblitz_Rasenerde_10l_2aa6048f-a913-4516-93e1-129c540f5b06_300x.jpg',
      sizes: [
        { deckung: 10, menge: 10, id: 51237866242395, price: 13.99, label: '10 Liter · für ca. 10 m²' },
        { deckung: 20, menge: 20, id: 51278060355931, price: 19.99, label: '20 Liter · für ca. 20 m²' },
        { deckung: 30, menge: 30, id: 51278066778459, price: 27.99, label: '30 Liter · für ca. 30 m²' }
      ]
    }
  }
};